import axios, { axiosBaseConfig } from './axios'
import { ListDTO } from './dto/list.dto'
import { NewsDTO, NewsDataDTO } from './dto/news.dto'
import { TypeDto } from './dto/user.dto'
import { AuthService } from './auth.service'

class NewsServiceClass {
  async list (queryParams: { [key: string]: string | number } = {}) {
    const res = await axios.get<ListDTO<NewsDTO>>('/api/news', {
      params: queryParams
    })
    return res.data
  }

  async detail (slug: string) {
    const res = await axios.get<NewsDataDTO>(`/api/news/${slug}`)
    return res.data
  }

  createOrUpdate (news: NewsDTO) {
    return news.slug ? this.update(news) : this.create(news)
  }

  async create (news: NewsDTO) {
    let reqData = new FormData()
    Object.entries(news).forEach(([key, value]) => {
      if (value) {
        reqData.append(key, value)
      }
    })

    const res = await axios.post<NewsDTO>('/api/news', reqData)
    return res.data
  }

  async update (news: NewsDTO) {
    let reqData = new FormData()
    Object.entries(news).forEach(([key, value]) => {
      if (value && !((key === 'titleImage') && !value)) {
        reqData.append(key, value)
      }
    })
    reqData.append('_method', 'put')

    const res = await axios.post<NewsDTO>(`/api/news/${news.slug}`, reqData)
    return res.data
  }

  delete (slug: string) {
    return axios.delete(`/api/news/${slug}`)
  }

  async newsTypesList () {
    const res = await axios.get<ListDTO<TypeDto>>('/api/news/newsTypes')
    return res.data
  }

  saveContent (slug: string) {
    return {
      url: `/api/news/${slug}/content`,
      baseConfig: {
        ...axiosBaseConfig,
        headers: {
          ...axiosBaseConfig.headers,
          Authorization: 'Bearer ' + AuthService.token
        }
      }
    }
  }
}

const NewsService = new NewsServiceClass()

export {
  NewsService
}
